var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05557 0C12.5046 0 16.1111 3.6066 16.1111 8.05556C16.1111 9.97989 15.4364 11.7466 14.3106 13.132L19.7559 18.5775C20.0814 18.9029 20.0814 19.4305 19.7559 19.7559C19.4601 20.0518 18.9971 20.0787 18.6709 19.8366L18.5775 19.7559L13.132 14.3106C11.7466 15.4363 9.9799 16.1111 8.05557 16.1111C3.60659 16.1111 0 12.5046 0 8.05556C0 3.6066 3.60659 0 8.05557 0ZM8.05557 1.66667C4.52707 1.66667 1.66667 4.52707 1.66667 8.05556C1.66667 11.584 4.52707 14.4445 8.05557 14.4445C11.584 14.4445 14.4445 11.584 14.4445 8.05556C14.4445 4.52707 11.584 1.66667 8.05557 1.66667Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchblue);
export default __webpack_public_path__ + "static/media/searchblue.4e5e4853ca25768c670f8e2c049adb9e.svg";
export { ForwardRef as ReactComponent };